import React from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import iconEmail from '../../../../images/email.svg'
import iconPhone2 from '../../../../images/phone2.svg'
import iconPhone from '../../../../images/iphone.svg'
import iconLine from '../../../../images/line.svg'
import IconHome from '../../../../images/home.svg'
import { BsRecordFill } from 'react-icons/bs'
import imgUser from '../../../../images/user-bg.png'
import ImgBGProfile from '../../../../images/bg-profile.png'

function FormPresonal({ profile }) {
  return (
    <>
      <div className="position-relative">
        <Image src={ImgBGProfile} fluid />
        <div
          className="position-absolute"
          style={{
            top: '60%',
            left: '20%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Image
            src={profile?.image_url ?? imgUser}
            fluid
            style={{ width: '100px', height: '100px', objectFit: 'cover' }}
            className="rounded-circle bg-white"
            onError={(event) => {
              event.target.src = imgUser
              event.onerror = null
            }}
          />
        </div>
      </div>

      <p className="text-center mb-0 mt-3 ">
        <span className="me-2">
          {profile?.title_en} {profile?.name_en} {profile?.surname_en}
        </span>
      </p>

      <p className="text-center fw-light small mb-0">
        {profile?.title_th}
        {profile?.name_th} {profile?.surname_th} ({profile?.nickname_th})
      </p>
      <div
        className="m-1 p-2 rounded-3 "
        style={{ backgroundColor: '#EEF4FF' }}
      >
        <div className="d-flex justify-content-between border-bottom ">
          <p className="mb-2 small">Applied Jobs</p>
          <p className="font-small-2 mb-2 fw-light text-muted">
            {profile?.date_applied_job}
          </p>
        </div>
        <Row>
          <Col xl={6}>
            <div className="font-small-2 mt-2 me-2 ">
              <p className=" m-0 fw-normal">Code </p>
              <p className="text-muted text-start">{profile?.code}</p>
            </div>
          </Col>
          <Col xl={6}>
            <div className="font-small-2 mt-2 me-2 ">
              <p className=" m-0 fw-normal">Type </p>

              <p className="text-muted text-start">
                <BsRecordFill /> {profile?.type}
              </p>
            </div>
          </Col>
        </Row>

        <p className="font-small-2 m-0">Group </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.division_en || '-'}
          <span>{` (${profile?.division || ''})`}</span>
        </p>

        <p className="font-small-2 m-0">Division </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.faction_en || '-'}
          <span>{` (${profile?.faction || ''})`}</span>
        </p>
        <p className="font-small-2 m-0">Department</p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.department_en || '-'}
          <span>{` (${profile?.department || ''})`}</span>
        </p>

        <p className="font-small-2 m-0">Team </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.team_en || '-'}
        </p>

        <p className="font-small-2 m-0">Position </p>
        <p className="font-small-2 fw-light text-muted ">
          {profile?.position_en || '-'}
        </p>

        {/* <p className="font-small-2 mt-2">{profile?.position_en}</p>
        <p className="font-small-2 mb-2 fw-light fw-light text-muted">
          {profile?.team_en}
        </p>
        <p className="font-small-2 fw-light fw-light text-muted">
          {profile?.faction_en} ({profile?.faction})
        </p> */}
      </div>
      <p className="mt-3">Contact</p>

      <div className="d-flex small">
        <Image src={iconEmail} fluid width={15} className="mb-5" />{' '}
        <div className="ms-2">
          <p className="small mb-1 text-muted fw-light">Email</p>
          <p className="">{profile?.email !== '' ? profile?.email : '-'}</p>
        </div>
      </div>
      <div className="d-flex small">
        <Image src={iconPhone} fluid width={11} className="mb-5" />{' '}
        <div className="ms-2">
          <p className="small mb-1 text-muted fw-light">Phone</p>
          <p className="">{profile?.phone !== '' ? profile?.phone : '-'}</p>
        </div>
      </div>

      <div className="d-flex small">
        <Image src={iconLine} fluid width={15} className="mb-5" />{' '}
        <div className="ms-2">
          <p className="small mb-1 text-muted fw-light">Line ID</p>
          <p className="">
            {profile?.line_id
              ? profile?.line_id.trim()
                ? profile?.line_id
                : '-'
              : '-'}
          </p>
        </div>
      </div>

      <div className="d-flex small">
        <Image src={iconPhone2} fluid width={18} className="mb-5" />{' '}
        <div className="ms-2">
          <p className="small mb-1 text-muted fw-light">Internal Number</p>
          <p className="">
            {profile?.intra_tel
              ? profile?.intra_tel.trim()
                ? profile?.intra_tel
                : '-'
              : '-'}
          </p>
        </div>
      </div>
      <div className="d-flex small">
        {/* <IconHome />{' '} */}
        <Image src={IconHome} fluid width={18} className="mb-5" />{' '}
        <div className="ms-2">
          <p className="small mb-1 text-muted fw-light">Address</p>
          <p className="">
            {profile?.address_current} {profile?.sub_district_current}{' '}
            {profile?.district_current} {profile?.province_current}{' '}
            {profile?.post_code_current}
          </p>
        </div>
      </div>
    </>
  )
}

export default FormPresonal
